import React from "react";
import "./style.css";
import Button from "@mui/material/Button";
import { Storefront } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import bg from "../../../../assets/pink-bg-woman.png"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../../../State/Store";
export const SellerImage = () => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isXLarge = useMediaQuery(theme.breakpoints.up("xl"));
  const isMed = useMediaQuery(theme.breakpoints.up("md"));
  const heroHeight =isXLarge?"80vh": isLarge ? "60vh" : isMed ? "50vh" : "45vh";
  const bgPosition = isLarge ? "top" : isMed ?"13% bottom" : "15% bottom";
  const seller = useAppSelector(s=>s.seller)
  const handleNavigate = () => { 
    if(!seller.profile) return navigate("/become-seller")
    return navigate("/seller/account")
   }
  const navigate = useNavigate()
  return (
    <section  style={{
      backgroundImage: `url(${bg})`,
      backgroundSize:  "cover",
      backgroundPosition: bgPosition, 
      width:"100%",
      height: heroHeight,
      backgroundRepeat:"no-repeat",
      objectFit:"contain"
    }} className="  relative m-0 xl:my-10 " >
      {/* <img
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize:  'cover',
          backgroundPosition:bgPosition, 
          width:'100%',
          height: heroHeight,
          backgroundRepeat:'no-repeat',
          objectFit:'contain'
        }}
        src={bg}
        alt=""
      /> */}
      {/* //transform translate-x-1/2: Shifts the element back by 50% of its own width, effectively centering it. */}
      <div className="absolute top-[25%] lg:top-[35%] right-4 md:right-[10rem] lg:right-[20rem] transform lg:translate-x-1/2 font-semibold text-2xl lg:text-5xl space-y-3">
        <h1 className="text-gray-400 text-xl md:text-5xl lg:text-6xl">Sell your product</h1>
        <p className="text-gray text-sm md:text-2xl lg:text-4xl ">
          With <span className="logo">VendorVersify</span>
        </p>
        <div className="lg:pt-6 flex ">
          <Button onClick={handleNavigate} style={isLarge?{fontSize:"2rem"}:isMed?{fontSize:"20px"}:{fontSize:"3vw"}} size={isLarge?'large':'small'} startIcon={<Storefront />} variant="contained">
            Become Seller
          </Button>
        </div>
      </div>
    </section>
  );
};
